module.exports = __webpack_public_path__ + "f0c503765e5c8d852b1ec6d930cf29fa.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-28.png
// module id = 1438
// module chunks = 0